import './index.css';

import { goloomSdk } from '../../features/goloom-sdk';
import { getLastConferenceConfig } from '../last-conference-config';

type BugData = {
    room_id: string;
    participant_id: string;
    meeting_url: string;
    meeting_problem: string;
    media_platform: string;
};

class BugFormController<Data> {
    data: Maybe<Partial<Data>> = undefined;

    init() {
        window.addEventListener('butterfly/open', () => {
            getLastConferenceConfig().then((config) => {
                const data = {
                    room_id: config?.room_id,
                    participant_id: goloomSdk.myUserId,
                    meeting_url: window.location.href,
                    meeting_problem: window.location.href,
                    media_platform: config?.media_platform,
                };
                window.dispatchEvent(
                    new CustomEvent('butterfly/v1/update-form-data', {
                        detail: {
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore - timeStyle относительно новый и типы о нем не знают
                            time: new Date().toLocaleString(navigator.language, {
                                timeStyle: 'short',
                                dateStyle: 'short',
                                hour12: false,
                            }),
                            ...data,
                        },
                    })
                );
            });
        });
    }

    setData(_data: Partial<Data>) {
        this.data = _data;
    }
}

export const bugFormController = new BugFormController<BugData>();
